import { Reveal } from "../presentation";
import { BrandMedia } from "../BrandMedia";
import { BrandQuote } from "../BrandQuote";

export default function BrandSlide({ slide, index }) {
  const { id, layout = "story", title, accent, subtitle, eyebrow, media, notice, quote, smallTitle } = slide;
  const isWordmark = layout === "cover";
  const Heading = layout === "cover" ? "h1" : "h2";

  return (
    <section
      id={id}
      className={`about-immersive theme-dark brand-slide brand-${layout}`}
      aria-labelledby={`${id}-title`}
      data-testid={`slide-${id}`}
    >
      {media && <BrandMedia media={media} id={id} eager={index === 0} />}
      {media && <div className="about-immersive-scrim" aria-hidden="true" />}
      <div className="about-immersive-grain" aria-hidden="true" />
      <div className="about-immersive-inner brand-slide-inner">
        <div className="about-immersive-content brand-copy">
          {eyebrow && <Reveal testid={`${id}-eyebrow`} className="brand-eyebrow">{eyebrow}</Reveal>}
          <Reveal delay={1} testid={`${id}-title-reveal`}>
            <Heading
              id={`${id}-title`}
              className={isWordmark ? "cover-wordmark brand-wordmark" : "editorial editorial-lg brand-headline"}
              data-testid={`${id}-headline`}
            >
              {smallTitle ? <span className="brand-title-small" data-testid={`${id}-small-title`}>{title}</span> : title}
              {accent && <> <span className="gold brand-accent">{accent}</span></>}
            </Heading>
          </Reveal>
          {subtitle && (
            <Reveal delay={2} as="p" className="brand-subtitle" testid={`${id}-subtitle`}>
              {subtitle}
            </Reveal>
          )}
          {quote && (
            <Reveal delay={2} testid={`${id}-quote-reveal`}>
              <BrandQuote quote={quote} id={id} />
            </Reveal>
          )}
          {notice && (
            <Reveal delay={2} testid={`${id}-notice-reveal`}>
              <aside className="brand-notice" aria-label="Confidentiality warning" data-testid={`${id}-notice`}>
                <strong className="brand-notice-label" data-testid={`${id}-notice-label`}>{notice.label}</strong>
                <p data-testid={`${id}-notice-text`}>{notice.text}</p>
              </aside>
            </Reveal>
          )}
          {media?.watchUrl && (
            <Reveal delay={3} testid={`${id}-film-link-reveal`}>
              <a className="pill" href={media.watchUrl} target="_blank" rel="noopener noreferrer" data-testid="production-film-youtube-link">
                Watch on YouTube <span className="arrow" aria-hidden="true">↗</span>
              </a>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}